<template>
	<article id="home-page" class="column content page">
    <div id="home">
      <div class="top3 three"></div>
      <h1 class="top">Ready Made Go 3</h1>
      <div class="mid3 three"></div>
      <h1 class="mid">20&ndash;24 September<br>2017</h1>
      <h1 class="bot">Ace Hotel<br>London</h1>
      <div class="bot3 three"></div>
      <div class="right3 three"></div>
      <router-link to="/audio-tour" class="button audiotour">Start Audio Tour</router-link>
    </div>
  </article>
</template>

<script>
export default {
  name: 'home-page',
  beforeCreate: function () {
    document.body.className = 'home-page'
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  article.column {
    padding: 0 .5rem;
    height: calc(100vh - .5rem);
    overflow: hidden;
  }
  #home {
    height: 100%;
    overflow: hidden;
  }

  h1 {
    margin: 0;
    position: absolute;
    line-height: 1;
  }
  h1:not(:first-child) {
    margin-top: 0;
  }
  h1.top {
    top: 25%;
    margin-top: -.5rem;
  }
  h1.mid {
    top: calc(50% + 0rem);
  }
  h1.bot {
    bottom: calc(0rem + 4.75rem);
    left: 33.3333%;
    left: calc(50% - 1.75rem);
    margin-left: -1.75rem;
  }

  .three {
    background-color: #ffc4c7;
    width: 1.5rem;
    height: 1.5rem;
    position: absolute;
  }
  .top3, .mid3, .bot3 {
    width: auto;
    left: .5rem;
    right: .5rem;
  }
  .top3 {
    top: .5rem;
  }
  .mid3 {
    top: 50%;
    margin-top: -2rem;
  }
  .bot3 {
    bottom: 3rem;
  }
  .right3 {
    top: 1.75rem;
    bottom: 3.5rem;
    right: .5rem;
    height: calc(100% - 6rem);
  }
  .audiotour {
    position: absolute;
    bottom: 0rem;
    height: 2.5rem;
    width: calc(100% - 1rem);
    text-transform: uppercase;
    background-image: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/HomePage.vue?507721c1